import { DATASOURCE } from 'Constants'

const initialState = {
  data:{},
  loading: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case DATASOURCE.MODALITY.KEY:
      let data = action.data;
      return {
        ...state,
        data: data,
        loading: false
      };
    case DATASOURCE.MODALITY.LOADING:
      return {
        ...state,
        data: {},
        loading: true
      };
    default:
      return state;
  }
};

